export function appMessage(messageText, options = {}) {
  const safeMessageText = HubstaffUtils.escapeHTML(messageText);
  const header = `<i class="fa fa-info-circle"></i> ${options.header || 'Notice'}`;
  const messageOptions = {
    life: 5000,
    ...options,
    header,
  };

  $.jGrowl(safeMessageText, messageOptions);
}

export default {
  install(app, _options) {
    app.config.globalProperties.$appMessage = appMessage;
    app.config.globalProperties.$clearAppMessage = () => {
      $("div.jGrowl").jGrowl("close");
    };
  },
};
